/**
 * The message shown when "Why exactly?" cannot produce a decision explanation.
 *
 * <p>xt run 20260913-214629: the explain call failed because the edge relayed a tool-catalog
 * action kind the entitlements evaluator does not accept, and the user was told "Could not retrieve
 * the decision explanation right now." — a retry prompt for something that would fail identically,
 * on the very screen whose purpose is to make a denial understandable. The BFF now relays the
 * evaluator's own problem detail (code + detail) in the query envelope's `error`, which
 * AssistQueryService surfaces as the stream error's message; this keeps that message instead of
 * flattening every failure into the same sentence.
 *
 * <p>Transport failures (no envelope, no upstream message) keep the generic sentence: there is
 * genuinely nothing to report and a retry may work.
 */
import { HttpErrorResponse } from '@angular/common/http';

export const EXPLAIN_DECISION_GENERIC_ERROR =
  'Could not retrieve the decision explanation right now.';

export function explainDecisionErrorMessage(err: unknown): string {
  if (err instanceof HttpErrorResponse) return EXPLAIN_DECISION_GENERIC_ERROR;
  const message = err instanceof Error ? err.message?.trim() : null;
  return message ? message : EXPLAIN_DECISION_GENERIC_ERROR;
}
